import { render, staticRenderFns } from "./FamAddress.vue?vue&type=template&id=2e39db71&"
import script from "./FamAddress.vue?vue&type=script&lang=js&"
export * from "./FamAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FamAddress.vue"
export default component.exports